<template lang="pug">
    .wam-select__double-wrapper(:title="periodLabel + ' - ' + frequencyLabel")
        WamSelect(
            label="period"
            icon="period"
            :value="criterion.frequencyPeriodSelected"
            :options="criterion.smartSegments"
            optionKey="id"
            optionName="periodInString"
            :longValueName="criterion.frequencyPeriodSelected && criterion.frequencyPeriodSelected.periodTo != 0"
            :valueName="criterion.frequencySelectedInString"
            @change="periodChange"
        )

        WamSelectRange(
            label="frequency"
            icon="frequency"
            :disabled="criterion.frequencyRange.disabled"
            disabledMessage="First, choose a period"
            :value="criterion.frequencyRange.value"
            :valueName="criterion.frequencyRangeInString"
            :longValueName="criterion.frequencyRange.value && !criterion.frequencyRange.disabled"
            @change="frequencyChange($event)"
            :min="1"
            :max="20"
            :marks="{ 1: '1', 20: { style: { width: 'max-content'}, label: '20+'}}"
        )
</template>

<script>
import WamSelect from '../../common/WamSelect/WamSelect'
import WamSelectRange from '../../common/WamSelect/WamSelectRange'

export default {
    components: {
        WamSelect,
        WamSelectRange
    },

    props: {
        criterion: {
            type: Object,
            required: true
        }
    },

    computed: {
        frequencyLabel() {
            const frequency = this.criterion.frequencyRange.value
            if (!frequency) return ' Frequency '
            if (frequency[0] === frequency[1]) return 'Frequency: equal to ' + frequency[0]
            return 'Frequency: from ' + frequency[0] + ' to ' + frequency[1]
        },

        periodLabel() {
            if (!this.criterion.frequencyPeriodSelected) return 'Period '
            return 'Period: ' + this.criterion.frequencyPeriodSelected.periodInString
        }
    },

    methods: {
        periodChange(value) {
            if (!this.criterion.frequencyPeriodSelected || value != this.criterion.frequencyPeriod.value) {
                this.$emit('periodChange', value)
            }
        },

        frequencyChange(value) {
            this.$emit('frequencyChange', value)
        }
    }
}
</script>
